// Where the backend's API is: the live server unless REACT_APP_API_BASE says otherwise. For working on the site
// locally, put REACT_APP_API_BASE=http://localhost:8000/api in frontend/.env.development.local (kept out of git, and
// only read by "yarn start", so a production build always gets the live server).
let API_BASE = process.env.REACT_APP_API_BASE || 'https://api.clomp.io/api';

// OAuth client id for Sign in with Google. Set REACT_APP_GOOGLE_CLIENT_ID (e.g. in frontend/.env.local); the Google
// button is hidden when it's missing.
let GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || ''

export { API_BASE, GOOGLE_CLIENT_ID }
